module.exports = __webpack_public_path__ + "grey-block-image.2c3d8e0fb636e8581f9ed9b7f8bff57d.png";